module.exports = __webpack_public_path__ + "media/images/icon_profile-9ae4a52ac4b13b171ecefce99ff6dfe1.png";